import { IconGiveMoney, IconCoin, IconVelocimeter } from '@consumidor-positivo/aurora';

export const AppNavButtons = [
  { label: 'Score', path: '/meu-score', icon: <IconVelocimeter /> },
  { label: 'Crédito', path: '/minhas-ofertas', icon: <IconGiveMoney /> },
  { label: 'Dívidas', path: '/minhas-dividas', icon: <IconCoin /> },
];
